import SectionHeading from 'components/Content/SectionHeading/SectionHeading';

export default SectionHeading;
